<template>
  <Form id="spacForm" name="spacForm" ref="spacFormRef">
    <div class="search-wrap">
      <div class="select-wrap">
        <Field v-model="selectSpacType" ref="spacSelectRef" id="spacSelect" name="spacSelect" label="시험선택" rules="required" v-slot="{ field }">
          <div class="select-list" id="spac-list">
            <span class="list-label" id="spac-cur">{{ selectSpacText }}</span>
            <input type="hidden" v-bind="field" />
            <ul class="option-list">
              <li class="option-item" v-for="(item, index) in compSpacTypeList" :key="'spacList' + index" @click="selectItem(item)">
                {{ item.text }}
              </li>
            </ul>
          </div>
        </Field>
      </div>
      <div class="input-wrap">
        <Field v-model="spacTinNumber" ref="spacSelectRef" id="spacTinNum" name="spacTinNum" label="응시번호" rules="required|numeric" v-slot="{ field }" @input="inputTinNumber(spacTinNumber)">
          <input v-model="spacTinNumber" v-bind="field" type="text" placeholder="응시번호를 입력해주세요." @keydown.enter.prevent="checkGrade" />
        </Field>
      </div>
      <ul class="check-wrap">
        <li>
          <p @click="checkGrade">빠르게 성적 확인하기</p>
          <img @click="checkGrade" src="@/assets/imgs/main/arrow-right2.png" alt="보기" />
        </li>
        <li>
          <p @click="windowOpen('https://kr.object.ncloudstorage.com/hubsugang/spac-grade/230120_spacGradeTable.pdf')">등급체계도 보기</p>
          <img src="@/assets/imgs/main/arrow-right2.png" alt="보기" @click="windowOpen('https://kr.object.ncloudstorage.com/hubsugang/spac-grade/230120_spacGradeTable.pdf')" />
        </li>
      </ul>
    </div>
  </Form>
</template>

<script>
import { spacApi, spacWritingApi } from "@/plugins/apiUrl";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { computed, onMounted } from "@vue/runtime-core";
import _ from "lodash";
export default {
  setup() {
    const store = useStore();
    let eleBtn = null;
    let eleList = null;
    const spacFormRef = ref(null);
    const selectSpacType = ref("");
    const selectSpacText = ref("");
    const spacSelectRef = ref(null);
    const spacTinNumber = ref("");
    const numberREg = /[0-9]/g;

    const compSpacTypeList = computed(() => {
      const cloneSpacList = _.cloneDeep(store.getters.getSpacType);

      return cloneSpacList;
    });

    const checkGrade = async () => {
      const { validate } = spacFormRef.value;
      const { valid, errors } = await validate();

      if (!valid) {
        const firstKey = Object.keys(errors)[0];

        alert(errors[firstKey]);
        return false;
      }
      if (selectSpacType.value === "CTEST") {
        window.open(`${spacApi}/new/start_report.php?test_name=${selectSpacType.value}&tin_num=${spacTinNumber.value}`, "spac", "top=100, left=300, width=850, height=850");
      } else if (selectSpacType.value === "WTEST") {
        window.open(`${spacWritingApi}/report/pop_report?tin=${spacTinNumber.value}`, "spac", "top=100, left=300, width=1200, height=850");
      }
    };

    const windowOpen = (path) => {
      window.open(path, "_blank");
    };

    const inputTinNumber = (value) => {
      if (!numberREg.test(value)) {
        value = "";
        alert("숫자만 입력이 가능합니다.");
        spacTinNumber.value = "";
        return false;
      }
    };

    const addEventListener = () => {
      eleBtn.addEventListener("click", () => {
        if (eleList.classList.contains("active")) {
          eleList.classList.remove("active");
        } else {
          eleList.classList.add("active");
        }
      });
    };

    const selectItem = (selectItem) => {
      const { value, text } = selectItem;

      selectSpacType.value = value;
      selectSpacText.value = text;
      if (eleList.classList.contains("active")) {
        eleList.classList.remove("active");
      } else {
        eleList.classList.add("active");
      }
    };

    onMounted(() => {
      eleBtn = document.querySelector("#spac-cur");
      eleList = document.querySelector("#spac-cur ~ .option-list");

      if (store.getters.getSpacType.length) {
        const find = store.getters.getSpacType.find((item) => item.value === "");

        const { value, text } = find;
        selectSpacType.value = value;
        selectSpacText.value = text;
      }
      addEventListener();
    });

    return {
      spacFormRef,
      selectSpacType,
      selectSpacText,
      spacSelectRef,
      compSpacTypeList,
      checkGrade,
      spacTinNumber,
      inputTinNumber,
      windowOpen,
      selectItem,
    };
  },
};
</script>

<style lang="scss">
.select-wrap {
  padding: 10px 0;

  select {
    display: block;
    height: 100%;
    padding-right: 22px;
    background: url(@/assets/imgs/main/arrow-down.png) no-repeat center right;
    font-size: 16px;
    font-weight: $medium;
    cursor: pointer;
  }

  .select-list {
    position: relative;
    width: 150px;
    height: 35px;
    background: url(../assets/imgs/spac/arrow.svg) calc(100% - 10px) center no-repeat;
    cursor: pointer;
  }

  .list-label {
    display: flex;
    border: 0 none;
    outline: 0 none;
    align-items: center;
    background-color: transparent;
    width: inherit;
    height: inherit;
  }

  .option-list {
    position: absolute;
    transform: scaleY(0);
    top: 38px;
    left: 0;
    width: 100%;
    padding: 0;
    border: solid 1px $gray-e7e7e7;
    border-radius: 14px;
    background-color: $white;
    box-shadow: 0px 4px 40px 0 rgba(0, 0, 0, 0.13);
    transition: all 0.2s linear;

    &.active {
      transform: scaleY(1);
    }
  }

  .option-item {
    font-size: 16px;
    border-bottom: 1px solid $gray-e7e7e7;
    padding: 12px 15px;

    &:hover {
      background-color: $gray-e7e7e7;
    }
  }

  .option-item:first-child {
    &:hover {
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
    }
  }

  .option-item:last-child {
    border: none;

    &:hover {
      border-bottom-left-radius: 14px;
      border-bottom-right-radius: 14px;
    }
  }
}

.input-wrap {
  flex-grow: 1;
  border-left: 1px solid #cccccc;
  padding: 10px 0 10px 20px;
  margin: 8px 0;

  input[type="text"] {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 16px;
    color: $black;

    ::placeholder {
      color: #b2b2b2;
    }
  }
}

.check-wrap {
  display: flex;
  gap: 0 30px;
  padding: 10px 0;

  li {
    display: flex;
    align-items: center;
    gap: 0 7px;
    cursor: pointer;

    p {
      font-weight: $medium;
    }

    img {
      height: 9px;
      flex: none;
    }
  }
}
</style>
